import Vue from 'vue';

class GraficosService {

    getTotaisGerais() {
        return Vue.prototype.$axios.get('dashboard/chart/totais');
    }

    getTotaisMeses() {
        return Vue.prototype.$axios.get('dashboard/chart/meses');
    }

    getTotaisContratos() {
        return Vue.prototype.$axios.get('dashboard/chart/contratos');
    }

    getTotaisClientes() {
        return Vue.prototype.$axios.get('dashboard/chart/clientes');
    }

    getTotaisEsferas() {
        return Vue.prototype.$axios.get('dashboard/chart/esfera');
    }

    getTotaisEmpresas() {
        return Vue.prototype.$axios.get('dashboard/chart/empresa');
    }

    getTotaisRegua() {
        return Vue.prototype.$axios.get('dashboard/chart/regua');
    }

}

export default new GraficosService();
